<template lang="html">
  <div class="col text-center report-summary-group">
    <h4 class="title">{{ reportData[group].title }}</h4>
    <h3 class="score">{{ percent }}%</h3>
  </div>
</template>

<script>
export default {
  props: [ 'group', 'index' ],
  data() {
    return {
      form: this.$store.state.formData,
      reportData: this.$store.state.reporting,
      content: this.$store.state.content,
      docDefinition: this.$store.state.docDefinition,
    }
  },
  computed: {
    totScore() {
      let scores = [];
      let con = this.content;
      for(let v in con){
        let type = con[v].form.type;
        let opt = con[v].form.options;
        let group = con[v].form.group;
        if(group === this.group){
          if(type === 'checkbox' || type === 'checkbox2'){
            opt.forEach((x)=>{
              let score = x.score ? x.score : 0;
              scores.push(score);
            });
          } else {
            let groupScore = [];
            opt.forEach((x)=>{
              let score = x.score ? x.score : 0;
              groupScore.push(score);
            });
            scores.push(Math.max.apply(null,groupScore));
          }
        }
      }
      return scores.length ? scores.reduce((a,v)=>{ return a + v }) : 0;
    },
    score() {
      let scores = [];
      let form = this.form;
      for(let v in form){
        let group = form[v].group;
        if(group === this.group){
            let score = form[v].score ? form[v].score : 0
            scores.push(score);
        }
      }
      return scores.length ? scores.reduce((a,v)=>{ return a + v }) : 0;
    },
    percent() {
      return Math.round((this.score / this.totScore) * 100);
    }
  },
  created() {
    const table = {
      style: 'table',
      table: {
        body: [[], []]
      },
      layout: 'noBorders'
    }

    if ( this.index === 0 ) {
      // console.log('index 0');
      this.docDefinition.content.push( table );
    }

    const title = {
      text: this.reportData[this.group].title.toUpperCase(),
      style: 'tableHeader'
    }

    const score = {
      text: this.percent + '%',
      style: 'tableScore'
    }

    this.docDefinition.content[this.docDefinition.content.length - 1].table.body[0].push( title );
    this.docDefinition.content[this.docDefinition.content.length - 1].table.body[1].push( score );
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";
@import "../../assets/scss/mixins";

.report-summary-group {
  color: white;

  &:not(:last-child) {
    margin-bottom: gu(2);

    @media only screen and (min-width: 40rem) {
      margin-bottom: 0;
    }
  }

  .title {
    text-transform: uppercase;
    font-weight: $fwBold;
    line-height: 1;
    font-size: rem-calc(20);

    @media only screen and (min-width: 40rem) {
      font-size: rem-calc(25);
    }
    
    @media only screen and (min-width: 64rem) {
      font-size: rem-calc(30);
    }
  }

  .score {
    font-size: rem-calc(45);
    font-weight: $fwMed;
    margin-bottom: 0;
    line-height: 1;
  }
}
</style>
